import React from 'react';
import TasksListItem from '../../containers/tasks-list-item';
import { ListGroup, ListGroupItem } from 'reactstrap';
import './tasks-list.css';
import { func, object, arrayOf } from 'prop-types';

const TasksList = ({ tasks, onToggleImportant, onToggleCompleted, getDeleteTaskId, onEdit, onToggleShowModal }) => (
  <ListGroup className='app-list'>
    {tasks.map(({ id, ...itemProps }) => {
      return (
        <ListGroupItem key={id}>
          <TasksListItem
            {...itemProps}
            onToggleImportant={() => onToggleImportant(id)}
            onToggleCompleted={() => onToggleCompleted(id)}
            onEdit={text => onEdit(id, text)}
            onToggleShowModal={() => onToggleShowModal()}
            getDeleteTaskId={() => getDeleteTaskId(id)}
          />
        </ListGroupItem>
      )
    })}
  </ListGroup>
)

TasksList.propTypes = {
  onEdit: func,
  onToggleShowModal: func,
  onToggleCompleted: func,
  onToggleImportant: func,
  getDeleteTaskId: func,
  tasks: arrayOf(object),
}

TasksList.defaultProps = {
  onEdit: () => { },
  onToggleCompleted: () => { },
  onToggleShowModal: () => { },
  onToggleImportant: () => { },
  getDeleteTaskId: () => { },
  tasks: [{}],
}

export default TasksList